import { Pipe, PipeTransform } from '@angular/core';
import { hatPostKey, partLocationLabel } from './part-location';

type AnyRecord = Record<string, any>;

/**
 * `{{ hat | hatLocation: organization }}` → "Div. 2 / Dept. 4 Promotion & Marketing", so hats
 * with the same name ("Admin") can be told apart wherever they are listed or picked (ISS-020).
 * Takes a hat key, or a hat object that carries its post link or its key; "" when unknown.
 */
@Pipe({ name: 'hatLocation', standalone: true })
export class HatLocationPipe implements PipeTransform {
    transform(hat: string | AnyRecord | null | undefined, org: AnyRecord | null | undefined): string {
        if (!hat || !org) return '';
        const orgHats = org['orgHats'] || {};
        let doc: AnyRecord | undefined;
        if (typeof hat === 'string') {
            doc = orgHats[hat];
        } else if (hatPostKey(hat)) {
            doc = hat;
        } else {
            doc = orgHats[hat['key'] || hat['hatKey'] || hat['id'] || ''];
        }
        return partLocationLabel(org['orgParts'], hatPostKey(doc));
    }
}
